<template>
  <div class="good-details">
    <div class="kong">&nbsp;</div>
    <div class="goods">
      <van-card
          num="1"
          :price="goodDetail.goodPrice"
          :title="goodDetail.title"
          :thumb="goodDetail.mainImage"
      />
      <div class="heji">
        <span>共计1件商品，合计：</span>
        <span class="money">￥{{ goodDetail.goodPrice }}</span>
      </div>
      <div class="kefu">客服电话：{{ goodDetail.phone }}</div>
      <van-button type="danger" @click="sorry">去支付</van-button>
    </div>
    <login-modal ref="login"/>
  </div>
</template>
<script>
import Vue from 'vue';
import {ImagePreview, Card, Toast, Dialog} from "vant";
import LoginModal from "@/components/LoginModal";

export default {
  name: "goodDetails",
  components: {
    ImagePreview,
    Card,
    LoginModal,
  },
  data() {
    return {
      paymentId: "",
      sign: "",
      data: {
        money: "",
        cellId: 0,
        deviceNum: "",
        goodId: 0,
        skuId: null,
        openId: '',
        returnPath: "/mall/phone/pay"
      },
      goodDetail: {
        description: "",
        goodId: '',
        goodPrice: '',
        mainImage: "",
        subTitle: "",
        title: "",
        unit: "",
        phone: '13419507200',
      },
      id: '',
      out_trade_no: '',
      deviceNums: '',
      goodId: '',
      price: undefined,
      cup: undefined,
      openId: '',
    };
  },
  created() {
    // let id = this.$route.query.id*1;https://wd.wintexiot.cn/mall/phone/pay?id=115&goodId=2&deviceNum=000009
    let deviceNum = this.$route.query.deviceNum
    let id = this.$route.query.id
    let goodId = this.$route.query.goodId
    let price = this.$route.query.price
    let cup = this.$route.query.cup
    this.openId = localStorage.getItem('accessOpenId') ? localStorage.getItem('accessOpenId') : ''
    let openIdNmu = localStorage.getItem('openIdNmu') ? localStorage.getItem('openIdNmu') : ''
    if (!id && !deviceNum && !goodId) {
      price = localStorage.getItem('price') ? localStorage.getItem('price') : undefined
      cup = localStorage.getItem('cup') ? localStorage.getItem('cup') : undefined
      deviceNum = localStorage.getItem('deviceNum') ? localStorage.getItem('deviceNum') : ''
      goodId = localStorage.getItem('goodId') ? localStorage.getItem('goodId') : ''
      id = localStorage.getItem('id') ? localStorage.getItem('id') : ''
      if (!id && !deviceNum && !goodId) {
        this.$router.push({name: '404'})
      } else {
        this.id = id;
        this.deviceNums = deviceNum
        this.goodId = goodId
        this.price = price
        this.cup = cup
        this.getDataInfo(id)
        if (this.loginType == 2 && !this.openId) {
          if (!openIdNmu) {
            localStorage.setItem('openIdNmu', 1)
            this.confirmLock()
          }
        }
      }
    } else {
      this.id = id;
      this.deviceNums = deviceNum
      this.goodId = goodId
      this.price = price
      this.cup = cup
      localStorage.setItem('deviceNum', deviceNum)
      localStorage.setItem('price', price)
      localStorage.setItem('cup', cup)
      localStorage.setItem('goodId', goodId)
      localStorage.setItem('id', id)
      this.getDataInfo(id)
      if (this.loginType == 2 && !this.openId) {
        if (!openIdNmu) {
          localStorage.setItem('openIdNmu', 1)
          this.confirmLock()
        }
      }
    }
    let code = this.$route.query.code, state = this.$route.query.state
    if (code) {
      this.authorizationApi(code)
    }
  },
  methods: {
    // 支付宝支付
    alipayPhone() {
      this.$api.good.alipayPhone(this.data).then((res) => {
        if (res.code == 200) {
          window.location.href = res.sign
        } else {
          Toast(res.msg)
        }
      }).catch((err) => {
      });
    },
    // 微信支付
    wechatPhone() {
      this.$api.good.wechatPhone(this.data).then(res => {
        if (res.code == 200) {
          this.out_trade_no = res.data.out_trade_no
          this.onBridgeReady(res.data)
        } else {
          Toast(res.msg)
        }
      }).catch((err) => {
      });
    },
    onBridgeReady(params) {
      let that = this
      // 微信支付签名接口
      WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            appId: params.appId, // 公众号名称，由商户传入
            timeStamp: params.timeStamp, // 时间戳，自1970年以来的秒数
            nonceStr: params.nonceStr, // 随机串
            package: params.package,
            signType: params.signType, // 微信签名方式：
            paySign: params.paySign, // 微信签名
          },
          function (res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              Toast("支付成功")
            } else if (res.err_msg == 'get_brand_wcpay_request:cancel') {
              Toast("您已取消了支付")
            } else {
              Toast("支付失败，请重新支付")
            }
          }
      )
    },
    // 授权
    confirmLock() {
      let initData = {
        loginType: this.loginType,
        deviceNum: this.deviceNums
      }
      this.$api.login.loginInit(initData).then(res => {
        if (res.code == 200) {
          let redirect_uri = encodeURIComponent(res.redirect_uri), appid = res.appId
          this.goThere(appid)
        } else {
          this.$router.push({name: 'nonsupport'})
        }
      })
    },
    // 授权
    goThere(appid) {
      let redirect_uri = encodeURIComponent("https://wd.wintexiot.cn/mall/phone/pay")
      window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid + "&redirect_uri=" + redirect_uri + "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect"
    },
    // 授权
    authorizationApi(code) {
      let data = {
        code: code,
        deviceNum: this.deviceNums
      }
      this.$api.login.userAuthWeixin(data).then(res => {
        if (res.code == 200) {
          localStorage.setItem("accessOpenId", res.userInfo.openId)
          this.openId = res.userInfo.openId
        } else {
          Toast(res.msg);
        }
      })
    },
    // 支付
    sorry() {
      if (this.loginType == 2) {
        if (this.openId) {
          this.data.openId = this.openId
          this.wechatPhone()
        } else {
          localStorage.setItem('openIdNmu', 1)
          this.confirmLock()
        }
      } else {
        this.alipayPhone()
      }
    },
    // 获取详情
    getDataInfo() {
      let data = {
        price: this.price,
        cup: this.cup,
        goodId: this.goodId,
        deviceNum: this.deviceNums
      }
      this.$api.good.goodDetailByGoodId(data).then(res => {
        if (res.code == 200) {
          this.goodDetail = res.detail
          this.data.cellId = this.id
          this.data.money = res.detail.goodPrice
          this.data.deviceNum = this.deviceNums
          this.data.skuId = null
          this.data.goodId = this.goodId
          this.data.openId = this.openId
        } else {
          Toast(res.msg)
        }
      }).catch((err) => {
      });
    },
  }
};
</script>
<style scoped>
.good-details {
  height: 100%;
  font-size: 20px;
  width: 100%;
  background-color: #f7f8fa;
}

.good-details /deep/ .van-card__title {
  line-height: 60px;
  font-size: 32px;
  padding-top: 10px;
  color: #191919;
}

.good-details /deep/ .van-card__bottom {
  line-height: 60px;
  font-size: 30px;
  padding-top: 10px;
}

.good-details .van-card__bottom /deep/ .van-card__price {
  color: #191919;
}

.good-details .heji {
  overflow: hidden;
  margin: 0 30px;
}

.good-details .heji span {
  display: block;
  float: left;
  width: 50%;
  font-size: 30px;
  color: #8d8d8d;
  line-height: 70px;
}

.good-details .heji .money {
  text-align: right;
  font-size: 34px;
  color: #c00607;
}

.good-details .kefu {
  color: #c00607;
  margin: 0 30px;
  font-size: 30px;
  line-height: 70px;
  padding-bottom: 60px;
}

.good-details /deep/ .van-button--danger {
  width: 100%;
}
</style>